function parseObjectToArray (viewMap, filterArray, object) {
  // object = removeParseDefaults(object.toJSON())
  let finalArray = new Array(Object.keys(viewMap).length)
  Object.keys(object).forEach((key) => {
    finalArray[viewMap[key]] = object[key]
    if (object[key] !== undefined && object[key].length > 0 && filterArray !== undefined && filterArray.indexOf(key) > -1) {
      finalArray[key] = object[key]
    }
  })
  return finalArray
}

export function uploadedOffersResponseHelper (responseArray, viewMap, filterArray) {
  return responseArray.map(parseObjectToArray.bind(null, viewMap, filterArray))
}



// WEBPACK FOOTER //
// ./src/components/shared/helper/ParseObjectToArrayConverter.js